import _default from './Divider';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// /home/gitlab_ci_multi_runner/builds/88e00e75/0/bryx911/ua-download/~/semantic-ui-react/dist/es/elements/Divider/index.js
// module id = 780
// module chunks = 0